import { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { createUseStyles } from 'react-jss'
import { titleMarginBottom } from '../constants/layout'
import { formatDateTimeString } from '../utils/dateHelper'
import Card from '../components/Card'
import { Colors } from '../constants/colors';
import usePaydayActions from '../hooks/usePaydayActions';
import NavLink from '../components/NavLink';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useAppSelector } from '../redux/hooks';
import { PayrollFile } from '../redux/types';
import useDidUpdateEffect from '../hooks/useDidUpdateEffect';
import DetailsCard from '../components/DetailsCard';
import CardSection from '../components/CardSection';
import PayrollFileRowList from '../components/PayrollFile/PayrollFileRowList';

const PayrollFileDetails = () => {
  const styles = useStyles()
  const params = useParams<{paydayId: string, id: string}>()
  const navigate = useNavigate();

  const { getPaydayDetails } = usePaydayActions()

  const loading = useAppSelector(state => state.payday.loading)
  const payday = useAppSelector(state => state.payday.paydayDetails)

  const [payrollFile, setPayrollFile] = useState<PayrollFile>()

  useEffect(() => {
    if ((payday === null || payday.id !== params.paydayId) && params.paydayId) {
      getPaydayDetails(params.paydayId || '')
    } else {
      let payrollFile = payday?.payrollDetails?.payrollFiles.find(x => x.id === params.id)
      setPayrollFile(payrollFile)
    }
  }, [])

  useDidUpdateEffect(() => {
    if (payday != null) {
      let payrollFile = payday?.payrollDetails?.payrollFiles.find(x => x.id === params.id)
      setPayrollFile(payrollFile)
    }
  }, [payday])

return (
    <div className={styles.container}>
      <h1>Payroll file {payrollFile?.externalId}</h1>
      <div className={styles.actionBar}>
        <NavLink title='Back' icon={faArrowLeft} onClick={() => navigate(-1)} />
      </div>
      <CardSection>
        <DetailsCard>
          <h6>General information</h6>
          <p>Submission date: <span>{formatDateTimeString(payrollFile?.submittedDate)}</span></p>
          <p>Pay count: <span>{payrollFile?.payCount}</span></p>
          <p>Original pay count: <span>{payrollFile?.originalPayCount}</span></p>
        </DetailsCard>
      </CardSection>

      <PayrollFileRowList rows={payrollFile?.rows ?? []} />

    </div>
  )
}

export default PayrollFileDetails

const useStyles = createUseStyles({
  container: {
    '& h1': {
      marginBottom: titleMarginBottom
    },
    '& h2': {
      paddingTop: '30px',
      paddingBottom: '20px'
    }
  },
  actionBar: {
    marginTop: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
    gap: 10
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    padding: '3px 20px',
    margin: '10px 0',
    transition: '0.4s',
    border: '1px solid',
    borderColor: Colors.darkGray5
  },
  listCell: {
    flex: 1,
    padding: '0px 10px'
  },
})
